module.exports = __webpack_public_path__ + "static/img/1.fd2e6f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/1.png
// module id = aJzX
// module chunks = 0